import {
    BTX_TARIFF_CHANGE,
    BTX_VVL,
    SESSION_CURIOSITY_FLOW,
    SESSION_SAILS_VVL,
    URL_PARAMS,
} from '../constant';
import {
    BtxTypeWithoutCustomerType,
    EndpointType,
    InlifeCustomerType,
} from '../interfaces/main.interface';
import { getGoToUrl } from './getUrlParams.helper';

/**
 * redirect to endpoint using additionalPageOptions properties
 */
export const redirectToEndpoint = ({
    btx,
    customerType,
}: EndpointType) => {
    window.sessionStorage.removeItem(SESSION_CURIOSITY_FLOW);
    window.sessionStorage.removeItem(SESSION_SAILS_VVL);
    const gotoUrl = getGoToUrl();

    if (gotoUrl) {
        window.location.assign(appendQueryParams(gotoUrl));

        return;
    }

    const { endpoints } = window.additionalPageOptions;

    if (!customerType) {
        window.location.assign(appendQueryParams(endpoints[btx as BtxTypeWithoutCustomerType]));

        return;
    }

    if (btx === BTX_VVL) {
        window.location.assign(appendQueryParams(endpoints[btx as typeof BTX_VVL][customerType]));

        return;
    }

    window.location.assign(appendQueryParams(endpoints[btx as typeof BTX_TARIFF_CHANGE][customerType as InlifeCustomerType]));
};

/**
 * append current query params to the new follow-up url
 */
export const appendQueryParams = (url: string) => {
    const currentSearchParams = new URLSearchParams(window.location.search);
    const baseUrl = window.location.origin;
    const newUrl = new URL(url, baseUrl);
    currentSearchParams.forEach((value, key) => {
        if (!newUrl.searchParams.has(key) && !URL_PARAMS.includes(key)) {
            newUrl.searchParams.append(key, value);
        }
    });

    return newUrl.toString();
};
